<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <v-form>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-text-field
                  class="purple-input"
                  label="Titulo"
                  messages="Nome produto que será usado em todas as plataformas"
                  v-validate="'required'"
                  data-vv-name="product_name"
                  :error-messages="errors.collect('product_name')"
                  v-model="product.name"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Código de Barras (UPC)"
                  class="purple-input"
                  messages="Se você não tiver não tem problema, geramos um para você!"
                  v-model="product.upc"
                  v-validate="'required'"
                  data-vv-name="upc"
                  :error-messages="errors.collect('upc')"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="product.type"
                  v-validate="'required'"
                  :items="configs.product_types"
                  item-value="id"
                  item-text="name"
                  :error-messages="errors.collect('type')"
                  label="Formato de produto"
                  data-vv-name="type"
                  required
                  messages="Se você tiver dúvidas em qual opção escolher consulte a nossa <a target='_blank' href='#'>ajuda</a>."
                ></v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  label="Artista Principal"
                  class="purple-input"
                  messages="Nome que será utilizado em todas as plataformas"
                  v-model="product.main_artist"
                  :items="artistas"
                  item-value="id"
                  item-text="name"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="product.release_date"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="product.release_date"
                      label="Data de lançamento"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="product.release_date" locale="pt-br" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(product.release_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>

              <v-flex xs12 md12>
                <v-text-field
                  label="Gravadora"
                  class="purple-input"
                  messages="Se não tiver pode deixar vazio, incluiremos o seu nome aqui."
                  v-model="product.record_label_name"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Copyright do Produto ©" class="purple-input"
                   v-model="product.copyright"
                 />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Copyright da Gravação ℗"
                  placeholder
                  class="purple-input"
                  messages="Você pode alterar individualmente na faixa, caso haja mais de uma"
                  v-model="product.copyright_phonogram"
                />
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  class="purple-input"
                  label="Resumo"
                  value
                  v-model="product.release_text"
                  messages="Faça um resumo do seu produto. Um texto caprichado que pode ser usado como publicidade."
                />
              </v-flex>
              <v-flex xs12 text-xs-right></v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>

      <v-flex xs12 md4 style="background-color: rgb(239, 239, 239);">
        <v-avatar slot="offset" class="mx-auto d-block" size="250" tile>
          <v-icon v-if="!cover">add_a_photo</v-icon>
          <img v-if="cover" :src="cover" />
        </v-avatar>
        <v-card-text class="text-xs-center">
          <h4 class="card-title">Capa do Produto</h4>

          <p class="card-description">
            <br />Imagem com 1500x1500 JPEG OU PNG
          </p>

          <input v-if="!cover" color="success" type="file" @change="onFileChange" />

          <v-btn v-if="cover" color="success" @click="removeImage()">Trocar Imagem</v-btn>
        </v-card-text>
      </v-flex>
    </v-layout>

    <modal_message
      :dialog_opened="modal_dialog.dialog_opened"
      :title="modal_dialog.title"
      :message="modal_dialog.message"
      :btn_1_text="modal_dialog.btn_1_text"
      :btn_2_text="modal_dialog.btn_2_text"
      @btn_1_clicked="modal_dialog.btn_1_evnt"
      @btn_2_clicked="modal_dialog.btn_1_evnt"
    />
  </v-container>
</template>
  <script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VeeValidate from "vee-validate";
import modal_message from "../shared/modal_message";

Vue.use(VeeValidate);

export default {
  components: {
    modal_message
  },
  $_veeValidate: {
    validator: "new"
  },
  props: {
    product: Object
  },
  data: () => ({
    modal_dialog: {
      dialog_opened: false,
      title: null,
      message: null,
      btn_1_text: null,
      btn_2_text: null,
      btn_1_evnt: function() {},
      btn_2_evnt: function() {}
    },
    date: new Date().toISOString().substr(0, 10),
    modal: false,
    cover: null,
    cover_file: null,
    image_size: {},
    dictionary: {
      attributes: {
        email: "E-mail Address"
        // custom attributes
      },
      custom: {
        type: {
          required: "Formato do produto é um campo obrigatório"
        },
        product_name: {
          required: "Titulo é um campo obrigatório"
        },
        upc: {
          required: "O UPC/Código de barras é um campo obrigatório"
        }
      }
    }
  }),
  watch: {
    //mantém o produto no Parent sempre atualizado
    product: {
      handler: function(e) {
        this.$emit("product_change", this.product);
      },
      deep: true
    },
    /**
     * Validações da imagem
     * A imagem não é obrigatória para o cadastro dos metadados, mas quando enviada
     * é necessária estar de acordo com as especificações minimas.
     */
    image_size() {
      if (typeof this.image_size != "object") {
        return;
      }

      /**
       * Validamos se a imagem é quadrada primeiro
       */
      if (this.image_size.width !== this.image_size.height) {
        this.modal_dialog.title = "A imagem precisa ser quadrada!";
        this.modal_dialog.message =
          "As plataformas exigem que as imagens de capa sejam quadradas.Envie uma imagem com no minímo 1500x1500.";
        this.modal_dialog.btn_1_text = "Entendi";

        this.modal_dialog.btn_1_evnt = e => {
          this.modal_dialog.dialog_opened = false;
          this.cover = "";
        };
        this.modal_dialog.dialog_opened = true;
      }

      /**
       * Validamos se ela tem no minimo de 1500 por 1500
       */
      if (this.image_size.width < 1500) {
        this.modal_dialog.title = "Quase lá!";
        this.modal_dialog.message =
          "Envie uma imagem com no minímo 1500px de largura por 1500px de altura.";
        this.modal_dialog.btn_1_text = "Entendi";
        this.modal_dialog.btn_1_evnt = e => {
          this.modal_dialog.dialog_opened = false;
          this.cover = "";
        };
        this.modal_dialog.dialog_opened = true;
      }

      /*var blob_cover = new Blob([this.cover], {
          type: 'imagem/jpeg'
        });
        this.product.cover = blob_cover;*/
    }
  },
  beforeUpdate(){
    if( typeof( this.product.cover) == 'string' && this.cover == null ){
      this.cover = process.env.VUE_APP_BASE_URL+this.product.cover;
      console.log('cover_atualizada', this.cover);
    }
    else{
      //this.cover = this.pro
    }
  },
  mounted() {
    this.$validator.localize("pt_br", this.dictionary);
    //this.cover = this.product.cover;
  },
  computed: {
    ...mapGetters(["artistas", "configs"])
  },

  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;      
      this.createImage(files[0]);
    },
    createImage(file) {
      //var image = new Image();
      var reader = new FileReader();
      var vm = this;   

      reader.onload = e => {
        var _image = new Image();
        _image.src = e.target.result;
        this.cover = _image.src; //e.target.result;
        _image.onload = e => {
          this.image_size = { width: _image.width, height: _image.height };          
        };
        this.cover_file = file;

        this.$emit('cover_change', file);
      };
      reader.readAsDataURL(file);
    },
    removeImage: function() {
      console.log('removeImage chamado', this.cover);
      this.cover = null;
      this.product.cover = null;
      console.log('removeImage finalizado', this.cover);
      //this.cover_file = "";     
    },
    submit() {
      //valida e retorna um evento
      return this.$validator.validateAll();
    },
    clear() {
      this.$validator.reset();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>